import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TVisibilityLevel {
  id?: number;
  organisationId: number;
  documentTypeId: number;
  visibilityLevel: number;
  status: string;
  valid: boolean;
}

export interface IVisibilityLevel extends TVisibilityLevel {}

const VisibilityLevel = Model((model: TVisibilityLevel): IVisibilityLevel => {
  const _value: TVisibilityLevel = Object.assign({}, model);

  let _model = {
    get id() {
      return _value.id;
    },
    set id(value) {
      _value.id = value;
    },
    get organisationId() {
      return _value.organisationId;
    },
    set organisationId(value) {
      _value.organisationId = value;
    },
    get visibilityLevel() {
      return _value.visibilityLevel;
    },
    set visibilityLevel(value) {
      _value.visibilityLevel = value;
    },
    get status() {
      return _value.status;
    },
    set status(value) {
      _value.status = value;
    },
    get documentTypeId() {
      return _value.documentTypeId;
    },
    set documentTypeId(value) {
      _value.documentTypeId = value;
    },
    get valid() {
      return _value.valid;
    },
    set valid(value) {
      _value.valid = value;
    }
  };

  return ValidatableObject<IVisibilityLevel>(_model);
});

export default VisibilityLevel;
